
import { useAppContext } from "../../context/AppContext";
import { useEVMContext } from "../../context/EVMContext";
import { ArrowDownIcon, PlusIcon } from "../SVGIcons";

const AddAndWithdraw: React.FC<{
    handleAddCollateral: () => void;
    handleWithdraw: () => void;
}> = ({handleAddCollateral, handleWithdraw}) => {
    const { accounts } = useEVMContext();
    return <div className="flex justify-end gap-[12x]">
        {accounts[0] && <div className="flex gap-[12px]">
            <button
                onClick={handleAddCollateral}
                className="bg-[#00FFEE] text-black flex items-center gap-[4px] rounded-[100px] px-[24px] py-[12px] hover:opacity-80 transition-all 0.3s"
            >
                <PlusIcon fillColor="black" />
                Add Collateral
            </button>
            <button
                onClick={handleWithdraw}
                className="bg-[#262626] text-white flex items-center gap-[4px] rounded-[100px] px-[24px] py-[12px] hover:opacity-80 transition-all 0.3s"
            >
                <ArrowDownIcon fillColor="white" className="rotate-180" />
                Withdraw
            </button>
        </div>
        }
    </div >;
};

export default AddAndWithdraw;
